import { createSlice } from "@reduxjs/toolkit";
import Axios from "axios";
import { BASE_API_URL } from "../../utils/constants";
import { fetchAdminUsers } from "./AdminUserSlice";
import { useSelector } from "react-redux";

const baseURL = BASE_API_URL;

export const trackSlice = createSlice({
    name: "Nominationlist",
    initialState: {
        error: false,
        tracks: [],
        isUserExists: false,
        isLoaded: false,
        isDataSentSuccess: false,
        isDataSentFailure: false,
    },
    reducers: {
        setTracks: (state, { payload }) => {
            state.error = false;
            state.tracks = payload;
        },
        setError: (state) => {
            state.error = true;
        },
        setIsUserExists: (state, payload) => {
            state.error = false;
            state.isUserExists = payload;
        },
        setLoaded: (state, { payload }) => {
            state.isLoaded = true;
            state.isDataSentSuccess = false;
            state.isDataSentFailure = false;
        },
        setDataSuccess: (state, { payload }) => {
            console.log('payload', payload)
            state.isLoaded = false;
            state.isDataSentSuccess = payload;
            state.isDataSentFailure = false;
        },
        setDataFailure: (state, payload) => {
            state.isLoaded = false;
            state.isDataSentSuccess = false;
            state.isDataSentFailure = true;
        },
    },
});

// Action creators are generated for each case reducer function
export const { setTracks, setError, setIsUserExists, setLoaded, setDataFailure, setDataSuccess } =
    trackSlice.actions;

export default trackSlice.reducer;

export function addTrack(track, description, th, createdBy) {
    return (dispatch) => {
        dispatch(setLoaded())
        Axios.post(
            `${baseURL}/addTrack`,
            { track: track, description: description, th: th, createdBy: createdBy },
            {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => {
                dispatch(setDataSuccess(res.data.message))
                console.log("res from add track", res.data);
                dispatch(fetchTracks());
                dispatch(fetchAdminUsers());
            })
            .catch((err) => {
                dispatch(setError(err));
                dispatch(setDataFailure())
                console.error("error is", err);
            });
    };
}

export function addTrackTh(tracks) {
    return (dispatch, getState) => {
        // const tracks = getState().tracks?.tracks;
        console.log(tracks);
    };
}

export function editTrackTH(trackId, th) {
    return (dispatch) => {
        dispatch(setLoaded())
        Axios.post(
            `${baseURL}/editTrackTh`,
            { trackId: trackId, th: th },
            {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => {
                dispatch(setDataSuccess(res.data.message))
                console.log("res from edit track th", res.data);
                dispatch(fetchTracks());
                dispatch(fetchAdminUsers());
            })
            .catch((err) => {
                dispatch(setError(err.response?.data?.error || err.message));
                dispatch(setDataFailure())
                console.error("error is", err);
            });
    };
}

export const fetchTracks = () => {
    return (dispatch) => {
        Axios.get(`${baseURL}/getTracks`, {
            headers: {
                Authorization: localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch(setTracks(res.data));
            })
            .catch((err) => {
                dispatch(setError(err));
                console.error("error is", err);
            });
    };
};

export function editTrackState(id, state) {
    return (dispatch) => {
        dispatch(setLoaded())
        Axios.post(
            `${baseURL}/editTrackState`,
            { id: id, state: state },
            {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => {
                dispatch(setDataSuccess(res.data.message))
                console.log("res from edit track state", res.data);
                dispatch(fetchTracks());
                dispatch(fetchAdminUsers());
            })
            .catch((err) => {
                dispatch(setError(err));
                dispatch(setDataFailure())
                console.error("error is", err);
            });
    };
}

export function editTrack(id, trackName, trackDesc) {
    return (dispatch) => {
        dispatch(setLoaded())
        Axios.post(
            `${baseURL}/editTrack`,
            { id: id, trackName: trackName, trackDesc: trackDesc },
            {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => {
                dispatch(setDataSuccess(res.data.message))
                console.log("res from edit track", res.data);
                dispatch(fetchTracks());
                dispatch(fetchAdminUsers());
            })
            .catch((err) => {
                dispatch(setError(err));
                dispatch(setDataFailure())
                console.error("error is", err);
            });
    };
}

export function editThState(thDetails) {
    return (dispatch) => {
        dispatch(setLoaded())
        Axios.post(
            `${baseURL}/editThState`,
            { thDetails },
            {
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => {
                dispatch(setDataSuccess(res.data.message))
                console.log("res from edit th state", res.data);
                dispatch(fetchTracks());
                dispatch(fetchAdminUsers());
            })
            .catch((err) => {
                dispatch(setError(err.response?.data?.error || err.message));
                dispatch(setDataFailure())
                console.error("error is", err);
            });
    };
}